import { useEffect } from 'react';

export function useWindowResizeEvent(
  onScreenResize: (width: number, height: number) => void,
  callOnMount = false
) {
  useEffect(() => {
    const handleResize = () => {
      onScreenResize(window.innerWidth, window.innerHeight);
    };

    if (callOnMount) {
      handleResize();
    }
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [onScreenResize, callOnMount]);
}
